import { MemberApiService } from '@my-pages/services/MemberApiService';
import { UtilsApiService } from '@shared/_legacy/services/UtilsApiService';
import { keepPreviousData, useQuery, UseQueryOptions } from '@tanstack/react-query';
//TODO REMOVE TSYRINGE
import { container } from 'tsyringe';
import { getBaseEmploymentTypesListKey, getMemberEmploymentsCurrentKey, getMemberEmploymentsNextKey, getMemberEmploymentsPreviousKey } from '@my-pages/features/employment/data/queryKeys.ts';
import { IEmployment } from '@my-pages/features/employment/types/Employment.ts';

const utilsApiService = container.resolve(UtilsApiService);
const memberApiService = container.resolve(MemberApiService);

export const useGetEmploymentTypes = (queryOptions?: UseQueryOptions<string[]>) => {
    const {
        data: employmentTypes,
        isFetching: fetchingEmploymentTypes,
        ...query
    } = useQuery<string[]>({
        queryKey: getBaseEmploymentTypesListKey(),
        queryFn: () => utilsApiService.getEmploymentTypes().then((response) => response.data),
        placeholderData: keepPreviousData,
        ...queryOptions,
    });

    return { employmentTypes, fetchingEmploymentTypes, ...query };
};

export const useGetPreviousEmployments = (sessionId: any, queryOptions?: UseQueryOptions<IEmployment[]>) => {
    const {
        data: previousEmployments,
        isFetching: fetchingPreviousEmployments,
        ...query
    } = useQuery<IEmployment[]>({
        queryKey: getMemberEmploymentsPreviousKey(),
        queryFn: () => memberApiService.getPreviousEmploymentsForMember(sessionId).then((response) => response.data),
        placeholderData: keepPreviousData,
        ...queryOptions,
    });

    return { previousEmployments, fetchingPreviousEmployments, ...query };
};

export const useGetCurrentEmployments = (sessionId: any, queryOptions?: UseQueryOptions<IEmployment[]>) => {
    const {
        data: currentEmployments,
        isFetching: fetchingCurrentEmployments,
        ...query
    } = useQuery<IEmployment[]>({
        queryKey: getMemberEmploymentsCurrentKey(),
        queryFn: () => memberApiService.getCurrentEmploymentsForMember(sessionId).then((response) => response.data),
        placeholderData: keepPreviousData,
        ...queryOptions,
    });

    return { currentEmployments, fetchingCurrentEmployments, ...query };
};

export const useGetNextEmployments = (sessionId: any, queryOptions?: UseQueryOptions<IEmployment[]>) => {
    const {
        data: nextEmployments,
        isFetching: fetchingNextEmployments,
        ...query
    } = useQuery<IEmployment[]>({
        queryKey: getMemberEmploymentsNextKey(),
        queryFn: () => memberApiService.getNextEmploymentsForMember(sessionId).then((response) => response.data),

        placeholderData: keepPreviousData,
        ...queryOptions,
    });

    return { nextEmployments, fetchingNextEmployments, ...query };
};
